import * as React from 'react';
import { FC } from 'react';

import { ResponsiveCarousel } from 'components/responsive-carousel';

import { RewardsCarouselCard } from './rewards-carousel-card';
import { IRewardsCarouselViewProps } from './types';

export const RewardsCarouselView: FC<IRewardsCarouselViewProps> = ({ rewards }) => (
  <ResponsiveCarousel bgColor="transparent">
    {rewards.map(reward => (
      <RewardsCarouselCard reward={reward} key={reward._id} />
    ))}
  </ResponsiveCarousel>
);
